import PatternBg, { PatternBgProps } from './PatternBg';

export default PatternBg;

export type { PatternBgProps };
